import { METRIC_NAMES } from '@config/Consts';

class BotManagerMetricsModel {
  constructor(options) {
    this.id = options.id;
    this[METRIC_NAMES.AGENT_VIEW_METRICS_ONLINE_AGENTS] = options[METRIC_NAMES.AGENT_VIEW_METRICS_ONLINE_AGENTS];
    this[METRIC_NAMES.AGENT_VIEW_METRICS_AWAY_AGENTS] = options[METRIC_NAMES.AGENT_VIEW_METRICS_AWAY_AGENTS];
    this[METRIC_NAMES.AGENT_VIEW_METRICS_BACK_SOON_AGENTS] = options[METRIC_NAMES.AGENT_VIEW_METRICS_BACK_SOON_AGENTS];
  }
}

export default BotManagerMetricsModel;
